module.exports = __webpack_public_path__ + "static/media/loyalty-icon-web.40186d00.png";